/**
 * VERSIONE LIBRERIA 3
 */
var RenderCaptcha = Render.extend({
    type : 'captcha',
    classData : 'captcha',
    classTemplate : 'captcha',
    captcha_img_selector : '[data-captcha_img]',
    _renderEdit : function(jQe) {
        var self = this;
        var el = jQe.find('[data-render_control]');
        el.attr("name", self.key);
        el.attr("value", self.value);
        var src = jQe.find('img').prop('src');
        src += '&rand='+Math.floor((Math.random() * 10000) + 1);
        jQe.find(self.captcha_img_selector).prop('src',src);
    },
    _finalizeEdit : function() {
        var self = this;
        $(self.container).find('[data-captcha_img]').addClass('captchajs');
        $(self.container).find('[data-button_reload]').click(function () {
            self.reload();
        });
        self.reload();
    },
    reload : function () {
        var self = this;
        $.get(Facade.getUrl('/captchajs_img'),{},function (html) {
            $(self.container).find('[data-captcha_img]').html(html);
        });
        //$(cssClass).html(html);
        //$(self.config.container).find('[data-captcha_img]').prop('src',"/captchajs_img?rand="+(Math.random()*1000) );
        //});
    }
});

// metodo statico per il ricaricamento del captcha
Render.loadCaptcha = function ( cssClass ) {
    if (!cssClass) {
        cssClass = '.captchajs';
    }

    $.get(Facade.getUrl('/captchajs'),{},function (html) {
        $(cssClass).html(html);
    });
}
